// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1bAII","footer":"ModalError_footer__2D42Z"};